import type { FieldErrors } from 'react-hook-form';
import type { FormErrors, FormValues } from './formTypes';

const isPlainObject = (value: unknown): value is Record<string, unknown> => {
    if (typeof value !== 'object' || value === null) {
        return false;
    }
    if (Object.prototype.toString.call(value) !== '[object Object]') {
        return false;
    }
    const proto = Object.getPrototypeOf(value);
    return proto === Object.prototype || proto === null;
};

export const fieldErrorsToFormErrors = <TValues extends FormValues>(
    errors: FieldErrors<any>,
): FormErrors<TValues> => {
    const walk = (node: any): any => {
        if (!node) {
            return undefined;
        }
        if (typeof node.message === 'string') {
            return node.message;
        }
        if (Array.isArray(node)) {
            return node.map(walk);
        }
        if (isPlainObject(node)) {
            const out: Record<string, any> = {};
            for (const key of Object.keys(node)) {
                const v = walk(node[key]);
                if (v !== undefined) {
                    out[key] = v;
                }
            }
            return Object.keys(out).length ? out : undefined;
        }
        return undefined;
    };

    return (walk(errors) ?? {}) as FormErrors<TValues>;
};
